/* eslint-disable react/no-unescaped-entities */
import React, {
  forwardRef,
  memo,
  useCallback,
  useEffect,
  useState,
} from 'react';
import './gaugeChart.scss';

// const SIZE = {
//   small: 'small',
//   big: 'big',
// };

const sector = spawnSector(15);

/**
 * GaugeChart
 * @param size: big or small
 * @param value: accept float number range from 0~1
 * @param isEditing: boolean
 * @param onChange: callback when component inner value changed
 * @param background: modify background of center circle
 * @param controlled: whether is controlled component, for example: component is controlled by form
 * @param ref
 * @returns {JSX.Element}
 * @constructor
 */
function GaugeChart(
  {
    size = 'big',
    value,
    isEditing = false,
    onChange,
    background,
    controlled = true,
  },
  ref,
) {
  const [rotation, setRotation] = useState(0);
  const pointerRotation = rotation - 90;

  useEffect(() => {
    let nextRotation = 0;
    if (
      typeof value === 'string' &&
      ['low', 'medium', 'high'].includes(value)
    ) {
      switch (value) {
        case 'low': {
          nextRotation = 0;
          break;
        }
        case 'medium': {
          nextRotation = 90;
          break;
        }
        case 'high': {
          nextRotation = 180;
          break;
        }
      }
    } else if (typeof value === 'number') {
      nextRotation = value * 180;
    }
    setRotation(nextRotation);
  }, [value]);

  const onGaugeClick = useCallback(
    (e) => {
      const targetNode = e.target;
      if (targetNode.classList.contains('gauge-sector')) {
        const index = targetNode.dataset.index;
        const nextRotation =
          index === '14' ? 180 : (parseInt(index) + 1) * 12 - 6;
        if (!controlled) {
          setRotation(nextRotation);
        }
        onChange && onChange(nextRotation / 180);
      }
    },
    [controlled],
  );

  return (
    <div className={`gauge-chart-container ${size}`}>
      <span className="gauge-chart-text-medium">Medium</span>
      <span className="gauge-chart-text">Low</span>
      <div className="gauge-chart-center" onClick={onGaugeClick}>
        <div
          className="gray-circle"
          style={{ transform: `rotate(${rotation}deg)` }}
        />
        <div className="mask-circle" style={background ? { background } : {}} />
        {isEditing ? <>{sector}</> : null}
      </div>
      <span className="gauge-chart-text">High</span>
      <div
        className="pointer"
        style={{ transform: `rotate(${pointerRotation}deg)` }}
      >
        <div className="pointer-body" />
        <div className="pointer-circle" />
      </div>
    </div>
  );
}

function spawnSector(segment = 15) {
  return (
    <div>
      {new Array(segment).fill(null).map((_, index) => (
        <div className="gauge-sector" key={index} data-index={index} />
      ))}
    </div>
  );
}

GaugeChart.propTypes = {};

export default memo(forwardRef(GaugeChart));
